// UploadRssEpisodesList.tsx
import React from 'react'
import { UploadTask } from 'hooks/useUploadStore'

export const UploadRssEpisodesList = ({ episodes, handleUpload, uploads }) => {
  return (
    <div className="flow-root">
      <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
          <div className="relative">
            <table className="min-w-full table-fixed divide-y divide-gray-300">
              <tbody className="bg-white">
                {episodes.map((episode) => {
                  const currentUpload = uploads.find(
                    (upload) =>
                      upload.episodeUrl === episode.url && upload.type === 'rss'
                  )

                  return (
                    <tr key={episode.title} className="py-0.5">
                      <td
                        onClick={() => !currentUpload && handleUpload(episode)}
                        className={`max-w-xs overflow-hidden overflow-ellipsis whitespace-nowrap py-1 pl-2 text-xs ${
                          currentUpload
                            ? 'text-gray-400'
                            : 'cursor-pointer text-gray-500 hover:bg-toasty-blue-50'
                        }`}
                      >
                        - {episode.title}
                      </td>
                      <td className="py-1 pl-2 text-xs text-gray-500">
                        {currentUpload && (
                          <>
                            {currentUpload.status === 'uploading' && (
                              <span>
                                Uploading... {currentUpload.progress}%
                              </span>
                            )}
                            {currentUpload.status === 'error' && (
                              <span className="text-red-500">
                                Error: {currentUpload.error}
                              </span>
                            )}
                            {currentUpload.status === 'completed' && (
                              <span className="text-green-500">
                                Upload completed.
                              </span>
                            )}
                          </>
                        )}
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}
